import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConversationalHistoryForNRO = lazy(() =>
  import("@scenes/ConversationalHistory").then((module) => ({
    default: module.ConversationalHistory,
  }))
);

export const conversationalHistoryNRO: NavigationRoutingObject = {
  Component: ConversationalHistoryForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  heading: (t: I18nT<"dashboard-navigation">) => t("conversational-history-nro-heading", "Conversation History"),
  pageNameForTracking: () => "Conversational Conversation History",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("agent_console_conversational");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
